import { chunkArrayGeneric } from './';
/*
 * Generic type T as params type
 * Generic type R as Response type
 * @param array params to batch and split several request
 * @param cb callback to add custom parameters for each request
 * @param cbChunk callback to customize all parameters of the request
 * @param default size 100
 * @returns
 * Usage
 * example 1
 * batch<ContentChallengeResponse,Content>(
 * contentChallengeResponse,
 * cbForContentQueryResponse,
 * cbChunkContentQueryResponse
 * )
 * example 2
 * batch<string, ContentQueryResponse>(
 * checksums,
 * cbForContentQuery,
 * cbChunkContentQuery
 * );
 */
export async function batch(params, cb, cbChunk, size = 100) {
    const cbPromises = [];
    if (size <= 0) {
        throw Error('Invalid length');
    }
    chunkArrayGeneric(params, size).forEach((chunk) => {
        const data = [];
        chunk.forEach((item) => cbChunk(item, data));
        cbPromises.push(cb(data));
    });
    return await Promise.all(cbPromises);
}
